module.exports = __webpack_public_path__ + "bg_content.8ebbd9578469401bce83.png";


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/assets/image/bg_content.png
// module id = ../../../../../src/assets/image/bg_content.png
// module chunks = main